
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
			//ajax地址
			getDataList:`post /apis/moyin-tool/ai/doc/async/listRecord`,
			getVipInfo: `/apis/moyin-account/v1/vip/status`,
			deleteTask: `post /apis/moyin-tool/ai/doc/async/cancel`,
			deleteRecord: `post /apis/moyin-tool/ai/doc/async/delete`,

		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"textGenerateListPage"
			})
		}